// extracted by mini-css-extract-plugin
module.exports = {"crop":"EditIconComponent_crop__47Z5Y"};